<template>
  <div class="bg-neutral-800 rounded-lg border border-neutral-700 p-4 flex flex-col gap-1">
    <span class="text-xs text-neutral-400 uppercase tracking-wide inline-flex items-center gap-1">
      {{ label }}
      <InfoPopover v-if="info" :text="info" />
    </span>
    <span class="text-2xl font-bold text-neutral-100">{{ formattedValue }}</span>
    <div v-if="subtitle" class="text-xs text-neutral-400">{{ subtitle }}</div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import InfoPopover from '@/components/stats/InfoPopover.vue'

const props = defineProps<{
  label: string
  value: string | number
  subtitle?: string
  info?: string
  isPercent?: boolean
}>()

const formattedValue = computed(() => {
  if (typeof props.value !== 'number') {
    return props.value
  }
  if (props.isPercent) {
    return (props.value * 100).toFixed(1) + '%'
  }
  return props.value.toLocaleString()
})
</script>
